import React from 'react';
import PropTypes, { bool, string, arrayOf } from 'prop-types';
import classNames from 'classnames';
import { Image } from '@thd-olt-component-react/core-ui';

import './productImage.scss';

export const ProductImage = ({
  canonicalUrl,
  productLabel,
  brandName,
  images,
  summary,
  landscape,
  stickyHeader,
  disableLink
}) => {

  const classes = classNames(
    'pod-primary-image',
    {
      'pod-primary-image--summary': summary,
      'pod-primary-image--landscape': (landscape && stickyHeader)
    }
  );

  const imageUrl = (images?.find((img) => img.subType === 'PRIMARY') || {}).url;
  if (!imageUrl) return null;

  return (
    <div className={classes}>
      {
        imageUrl && (
          disableLink ?
            (
              <Image
                stretchy
                src={imageUrl.replace(/<SIZE>/g, '400')}
                alt={productLabel}
                title={`${brandName} ${productLabel}`}
                width={1}
                height={1}
              />
            )
            :
            (
              <a href={canonicalUrl}>
                <Image
                  stretchy
                  src={imageUrl.replace(/<SIZE>/g, '400')}
                  alt={productLabel}
                  title={`${brandName} ${productLabel}`}
                  width={1}
                  height={1}
                />
              </a>
            )
        )
      }
    </div>
  );
};

ProductImage.propTypes = {
  canonicalUrl: string.isRequired,
  productLabel: string.isRequired,
  brandName: string.isRequired,
  /* eslint-disable-next-line react/forbid-prop-types */
  images: arrayOf(PropTypes.object).isRequired,
  summary: bool,
  landscape: bool,
  stickyHeader: bool,
  disableLink: bool
};

ProductImage.defaultProps = {
  summary: false,
  landscape: false,
  stickyHeader: false,
  disableLink: false
};

ProductImage.displayName = 'ProductImage';